// Lot 3 — Texte d'accueil déplaçable.
// Position/taille du texte d'accueil et du bouton de lancement, stockées en POURCENTAGES
// (0–100) du viewport sur exhibit_home (colonnes text_x/text_y/text_width/text_height +
// launch_x/.../launch_height). NULL => placement par défaut du modèle (rétro-compatible).
//
// Les modèles d'accueil l'utilisent pour appliquer un override de position :
//   const { textStyle, launchStyle } = useHomeLayout(() => props.homeImage);
// puis :style="textStyle" sur le texte et :style="launchStyle" sur le bouton.
import { computed } from 'vue';

// Construit un style absolu en % à partir des colonnes, ou {} si non positionné.
function pctStyle(x, y, w, h) {
  if (x == null || y == null) return {};
  // position: fixed => relatif au viewport (l'accueil est toujours plein écran).
  // Uniforme sur les 7 modèles, sans dépendre de leur positioning interne.
  const s = {
    position: 'fixed',
    left: `${x}%`,
    top: `${y}%`,
    margin: 0,
    zIndex: 100,
  };
  if (w != null) s.width = `${w}%`;
  if (h != null) s.height = `${h}%`;
  return s;
}

export function useHomeLayout(getHome) {
  const home = () => getHome() || {};
  const textStyle = computed(() => {
    const h = home();
    return pctStyle(h.text_x, h.text_y, h.text_width, h.text_height);
  });
  const launchStyle = computed(() => {
    const h = home();
    return pctStyle(h.launch_x, h.launch_y, h.launch_width, h.launch_height);
  });
  // Vrai si l'expo a un positionnement personnalisé (utile pour des ajustements conditionnels).
  const hasLayout = computed(() => {
    const h = home();
    return h.text_x != null || h.launch_x != null;
  });
  return { textStyle, launchStyle, hasLayout };
}
